import moment from "moment";

export const ROUTES = {
  REBATE_REPORT: "/rebateReport",
  TRADE_REPORT: "/tradeReport",
  TRADE_REPORT_V2: "/tradeReportV2",
  DEPOSIT_REPORT: "/depositReport",
  DEPOSIT_DAILY_REPORT: "/depositDailyReport",
  FTD_DEPOSIT: "/ftDeposit",
  CAMPAIGN_REPORT: "/campaignReport",
  CHANNEL_DATA: "/channelData",
  CREDIT_CARD_TRANSACTION_REPORT: "/ccTransactionReport",
  CREDIT_CARD_WITHDRAWAL_DETAIL_REPORT: "/ccWithdrawDetailReport",
  MAU_DEPOSIT_WITHDRAW_REPORT: "/mauDepositWithdrawReport",
  FCS_DEPOSIT_WITHDRAW_REPORT: "/fcsDepositWithdrawReport",
  FCS_CC_TRANSACTION_REPORT: "/fcsCcTransactionReport",
  FCS_CC_DETAIL_REPORT: "/fcsCcDetailReport",
  REPORT_DOWNLOAD: "/reportDownload",
};

export const ACCOUNT_TYPES = {
  TRADING_ACCOUNT: 1,
  REBATE_ACCOUNT: 3,
  CPA_ACCOUNT: -100,
};

export const FUND_TYPES = {
  DEPOSIT: 1,
  WITHDRAW: 2,
  CASH_ADJUSTMENT: 3,
  DAP_WITHDRAW: -100,
};

export const DEPOSIT_PAYMENT_STATUS = {
  SUCCEED: {value: "5", label: "Succeed"},
};

export const WITHDRAW_PAYMENT_STATUS = {
  COMPLETED: {value: "7", label: "Completed"},
  SUCCESS: {value: "16", label: "Success"},
  PARTIAL_SUCCESS: {value: "17", label: "Partial Success"},
};

// ⚠️ FCS 报表专用常量(架构师复核 H2 修复):
// MT 字段保留不动(老 MT 报表还在用)。
// FCS 字段的 label 跟 hytech-payment Java 端 1:1:
//   入金 5  = "Success"  (MT 老 label 是 "Succeed")
//   出金 7  = "Complete"  (MT 老 label 是 "Completed")
//   出金 16 = "Success"   (一致)
//   出金 17 = "Partial Success" (一致)
// FCS 报表用这套常量,避免"选了 Success 显示 Succeed" 之类的 UI 毛刺。
export const FCS_DEPOSIT_PAYMENT_STATUS = {
  SUCCESS: {value: "5", label: "Success"},
};

export const FCS_WITHDRAW_PAYMENT_STATUS = {
  COMPLETE: {value: "7", label: "Complete"},
  SUCCESS: {value: "16", label: "Success"},
  PARTIAL_SUCCESS: {value: "17", label: "Partial Success"},
};

export const LOTS_SUFFIX = "_lots";

export const DEFAULT_DEPOSITATE_STATE = {
  reset: false,
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  accountType: ACCOUNT_TYPES["TRADING_ACCOUNT"],
  userAndLeve: "",
  mt4Account: true,
  deposit: true,
  withdraw: false,
  timeDifference: false,
  cashAdjustment: false,
  dapWithdraw: false,
  depositDataType: FUND_TYPES["DEPOSIT"],
  depositPaymentStatus: [DEPOSIT_PAYMENT_STATUS["SUCCEED"]],
  depositPaymentMethod: "",
  depositPaymentChannel: "",
  cashAdjustmentDataType: FUND_TYPES["CASH_ADJUSTMENT"],
  withdrawDataType: FUND_TYPES["WITHDRAW"],
  withdrawPaymentStatus: [
    WITHDRAW_PAYMENT_STATUS["COMPLETED"],
    WITHDRAW_PAYMENT_STATUS["SUCCESS"],
    WITHDRAW_PAYMENT_STATUS["PARTIAL_SUCCESS"],
  ],
  withdrawPaymentMethod: "",
  withdrawPaymentChannel: "",
  dapWithdrawDataType: FUND_TYPES["DAP_WITHDRAW"],
  dapWithdrawPaymentStatus: [
    WITHDRAW_PAYMENT_STATUS["COMPLETED"],
    WITHDRAW_PAYMENT_STATUS["SUCCESS"],
    WITHDRAW_PAYMENT_STATUS["PARTIAL_SUCCESS"],
  ],
  dapWithdrawPaymentMethod: "",
  dapWithdrawPaymentChannel: "",
};

export const DEFAULT_TRADE_STATE = {
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  accountType: ACCOUNT_TYPES["TRADING_ACCOUNT"],
  userAndLeve: "",
  mt4Account: true,
  action: "",
  server: [],
};

export const DEFAULT_REBATE_STATE = {
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  dataSource: "",
  tradeOnCredit: "0",
  userAndLeve: "",
};

export const DEFAULT_FTD_STATE = {
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  paymentMethod: "",
  paymentChannel: "",
  userAndLeve: "",
};

export const DEFAULT_CCTRANSACTION_STATE = {
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  userAndLeve: "",
  selectedCreditCardChannel: "",
  selectedTransactionType: "",
  selectedCcStatus: "",
  selectedSourceDataVerifyStatus: "",
};

export const DEFAULT_CCWITHDRAWDETAIL_STATE = {
  reset: false,
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  accountType: ACCOUNT_TYPES["TRADING_ACCOUNT"],
  userAndLeve: "",
  mt4Account: true,
  seletedCCWithdrawDetailStatus: [
    WITHDRAW_PAYMENT_STATUS["COMPLETED"],
    WITHDRAW_PAYMENT_STATUS["SUCCESS"],
    WITHDRAW_PAYMENT_STATUS["PARTIAL_SUCCESS"],
  ],
  seletedCCWithdrawDetailChannelList: [],
};

export const DEFAULT_MAU_DEPOSIT_WITHDRAW_STATE = {
  reset: false,
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  accountType: "",
  userAndLeve: "",
  mt4Account: true,
  deposit: true,
  withdraw: false,
  depositDataType: FUND_TYPES["DEPOSIT"],
  depositPaymentStatus: [DEPOSIT_PAYMENT_STATUS["SUCCEED"]],
  depositPaymentMethod: "",
  depositPaymentChannel: "",
  withdrawDataType: FUND_TYPES["WITHDRAW"],
  withdrawPaymentStatus: [
    WITHDRAW_PAYMENT_STATUS["COMPLETED"],
    WITHDRAW_PAYMENT_STATUS["SUCCESS"],
    WITHDRAW_PAYMENT_STATUS["PARTIAL_SUCCESS"],
  ],
  withdrawPaymentMethod: "",
  withdrawPaymentChannel: "",
};

export const DEFAULT_FCS_DEPOSIT_WITHDRAW_STATE = {
  reset: false,
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  userAndLeve: "",
  deposit: true,
  withdraw: false,
  depositDataType: FUND_TYPES["DEPOSIT"],
  // ⚠️ 用 FCS 专用常量(架构师复核 H2): label 跟 hytech-payment Java 端 1:1
  depositPaymentStatus: [FCS_DEPOSIT_PAYMENT_STATUS["SUCCESS"]],
  depositPaymentMethod: "",
  depositPaymentChannel: "",
  withdrawDataType: FUND_TYPES["WITHDRAW"],
  withdrawPaymentStatus: [
    FCS_WITHDRAW_PAYMENT_STATUS["COMPLETE"],
    FCS_WITHDRAW_PAYMENT_STATUS["SUCCESS"],
    FCS_WITHDRAW_PAYMENT_STATUS["PARTIAL_SUCCESS"],
  ],
  withdrawPaymentMethod: "",
  withdrawPaymentChannel: "",
};

export const DEFAULT_FCS_CCTRANSACTION_STATE = {
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  userAndLeve: "",
  selectedCreditCardChannel: "",
  selectedTransactionType: "",
  selectedCcStatus: "",
  selectedSourceDataVerifyStatus: "",
};

export const DEFAULT_FCS_CCDETAIL_STATE = {
  reset: false,
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  userAndLeve: "",
  // ⚠️ 用 FCS 专用常量(架构师复核 H2)
  selectedFcsCCDetailStatus: [
    FCS_WITHDRAW_PAYMENT_STATUS["COMPLETE"],
    FCS_WITHDRAW_PAYMENT_STATUS["SUCCESS"],
    FCS_WITHDRAW_PAYMENT_STATUS["PARTIAL_SUCCESS"],
  ],
  selectedFcsCCDetailChannelList: [],
};

export const DEFAULT_REPORT_DOWNLOAD_STATE = {
  fromDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
  toDate: moment().clone().format("YYYY-MM-DD"),
  reportType: "deposit_withdraw",
};
